// Rich SEO-optimized content per service page
// Maps URL slug → backend slug + detailed trilingual content

export const SERVICE_PAGES = {
  novias: {
    backend_slug: "bridal",
    hero_image: "https://images.pexels.com/photos/16096141/pexels-photo-16096141.png",
    gallery_category: "bridal",
    eyebrow: { es: "Maquillaje para Novias", en: "Bridal Makeup", jp: "ブライダルメイク" },
    title: {
      es: "Tu día más fotografiado merece un maquillaje que dure 14 horas.",
      en: "Your most photographed day deserves makeup that lasts 14 hours.",
      jp: "一生に一度の日には、14時間崩れないメイクを。",
    },
    intro: {
      es: "Soy Abril Suarez, maquillista profesional especializada en novias en Aguascalientes y todo el Bajío. Trabajo con piel real — no filtros — y técnicas de larga duración pensadas para fotografía, video, abrazos, lágrimas y baile.",
      en: "I'm Abril Suarez, a professional bridal makeup artist based in Aguascalientes serving brides across the Bajío region. I work with real skin — no filters — and long-lasting techniques designed for photography, video, hugs, tears and dancing.",
      jp: "私はアブリル・スアレス、アグアスカリエンテスを拠点とするブライダル専門のメイクアップアーティストです。フォト、動画、涙、ダンスにも耐える長時間メイクを得意としています。",
    },
    seo_title: {
      es: "Maquillaje para Novias en Aguascalientes · Abril Suarez Makeup Artist",
      en: "Bridal Makeup Artist in Aguascalientes · Abril Suarez",
      jp: "アグアスカリエンテスのブライダルメイク · アブリル・スアレス",
    },
    seo_desc: {
      es: "Maquillaje profesional para novias en Aguascalientes. Prueba previa incluida, look duradero para 14 horas, fotografía editorial y video. Reserva tu prueba en línea.",
      en: "Professional bridal makeup in Aguascalientes, Mexico. Trial session included, 14-hour long-lasting look, optimised for editorial photo + video. Book your trial online.",
      jp: "アグアスカリエンテスのプロフェッショナル・ブライダルメイク。トライアル付き、14時間崩れない仕上がり、フォト・ビデオ撮影に最適化。オンラインで予約可能。",
    },
    process: {
      es: [
        { t: "Consulta inicial", d: "Conversamos sobre tu vestido, locación, paleta de la boda y referencias visuales. Construyo un moodboard personalizado." },
        { t: "Prueba previa", d: "Sesión de 2 horas en la que ajustamos color, intensidad y longevidad. Te llevas fotografías de prueba." },
        { t: "El día de la boda", d: "Llego al lugar con todo el equipo. Maquillaje protagonista + retoques durante la sesión fotográfica." },
        { t: "Cobertura extendida", d: "Opción de quedarme para retoques post-ceremonia y antes del baile. Disponible como complemento." },
      ],
      en: [
        { t: "Initial consultation", d: "We talk about your dress, venue, wedding palette and visual references. I build a personalised moodboard." },
        { t: "Trial session", d: "A 2-hour session where we fine-tune colour, intensity and longevity. You leave with trial photos." },
        { t: "Wedding day", d: "I arrive on location with the full kit. Hero makeup + touch-ups during the photo session." },
        { t: "Extended coverage", d: "Option to stay for post-ceremony touch-ups before the reception. Available as an add-on." },
      ],
      jp: [
        { t: "初回相談", d: "ドレス、会場、テーマカラー、参考イメージについてお話しし、専用のムードボードを作成します。" },
        { t: "トライアル", d: "2時間のセッションで色味、強さ、持続性を調整。トライアル写真をお持ち帰りいただけます。" },
        { t: "挙式当日", d: "全機材を持参して現場に到着。メインメイク＋フォトセッション中のタッチアップ。" },
        { t: "延長対応", d: "披露宴前のタッチアップに残るオプションも追加可能です。" },
      ],
    },
    includes: {
      es: ["Prueba previa de 2 horas", "Productos de alta gama (Pat McGrath, Charlotte Tilbury, NARS, MAC Pro)", "Pestañas postizas premium incluidas", "Kit de retoques para el día", "Asesoría por WhatsApp hasta el día de la boda"],
      en: ["2-hour trial session", "High-end products (Pat McGrath, Charlotte Tilbury, NARS, MAC Pro)", "Premium false lashes included", "Touch-up kit for the day", "WhatsApp consultation until the wedding day"],
      jp: ["2時間のトライアル", "高級プロダクト（Pat McGrath、Charlotte Tilbury、NARS、MAC Pro）", "プレミアム付けまつげ込み", "当日用のタッチアップキット", "挙式当日までのLINE/WhatsApp相談"],
    },
    faq: {
      es: [
        { q: "¿Cuánto tiempo dura el maquillaje?", a: "Diseñado para durar 12-14 horas con productos waterproof, primer de larga duración y técnicas de fijación. Resiste lágrimas, abrazos y baile." },
        { q: "¿Viajas fuera de Aguascalientes?", a: "Sí. Cubro todo Aguascalientes, Zacatecas, San Luis Potosí, León y CDMX. El viaje y hospedaje se cotizan aparte." },
        { q: "¿Cuánto debo reservar de anticipo?", a: "Reservo tu fecha con el 30%. Una vez confirmada, esa fecha es exclusiva para ti." },
        { q: "¿Maquillas también a las mamás/damas?", a: "Sí, ofrezco paquete para novia + 2 a 6 acompañantes en el mismo lugar." },
      ],
      en: [
        { q: "How long does the makeup last?", a: "Designed to last 12-14 hours using waterproof products, long-wear primer and setting techniques. Survives tears, hugs and dancing." },
        { q: "Do you travel outside Aguascalientes?", a: "Yes. I cover all of Aguascalientes, Zacatecas, San Luis Potosí, León and CDMX. Travel and accommodation are quoted separately." },
        { q: "How much is the deposit?", a: "I book your date with 30% down. Once confirmed, that date is exclusively yours." },
        { q: "Do you do mothers / bridesmaids too?", a: "Yes — package for bride + 2 to 6 companions on the same location." },
      ],
      jp: [
        { q: "メイクの持続時間は？", a: "ウォータープルーフ製品、長持ちプライマー、フィキシングテクニックで12〜14時間持続するように設計されています。" },
        { q: "アグアスカリエンテス外への出張は可能ですか？", a: "はい。アグアスカリエンテス、サカテカス、サン・ルイス・ポトシ、レオン、メキシコシティに対応しています。交通費・宿泊費は別途お見積りです。" },
        { q: "デポジットはいくらですか？", a: "30%のデポジットでお日にちをご予約いただきます。" },
        { q: "母親や付き添いのメイクもしてもらえますか？", a: "はい、新婦＋同行者2〜6名のパッケージをご用意しています。" },
      ],
    },
  },

  editorial: {
    backend_slug: "editorial",
    hero_image: "https://images.unsplash.com/photo-1557924760-b14a6d4a4ef3?crop=entropy&cs=srgb&fm=jpg&q=85",
    gallery_category: "editorial",
    eyebrow: { es: "Maquillaje Editorial", en: "Editorial Makeup", jp: "エディトリアルメイク" },
    title: {
      es: "Construyo personajes. Diseño rostros para portada.",
      en: "I build characters. I design faces for the cover.",
      jp: "キャラクターを作り、表紙のための顔をデザインします。",
    },
    intro: {
      es: "Para campañas, lookbooks, editoriales de moda y producciones audiovisuales. Trabajo en colaboración con fotógrafas/os, directores creativos y stylists para llevar un concepto del moodboard a la cámara.",
      en: "For campaigns, lookbooks, fashion editorials and audiovisual productions. I collaborate with photographers, creative directors and stylists to take a concept from moodboard to camera.",
      jp: "キャンペーン、ルックブック、エディトリアル、映像作品向け。フォトグラファー、クリエイティブディレクター、スタイリストと協働し、コンセプトをカメラまで届けます。",
    },
    seo_title: {
      es: "Maquillaje Editorial en Aguascalientes y CDMX · Abril Suarez",
      en: "Editorial Makeup Artist · Aguascalientes & Mexico City · Abril Suarez",
      jp: "エディトリアルメイク アグアスカリエンテス／メキシコシティ · アブリル・スアレス",
    },
    seo_desc: {
      es: "Maquillaje editorial para campañas, lookbooks, portadas y producciones audiovisuales. Diseño de personajes y conceptos. Aguascalientes, CDMX y todo México.",
      en: "Editorial makeup for campaigns, lookbooks, covers and audiovisual productions. Character and concept design. Aguascalientes, Mexico City and across Mexico.",
      jp: "キャンペーン、ルックブック、表紙、映像制作のためのエディトリアルメイク。キャラクター・コンセプトデザイン。",
    },
    process: {
      es: [
        { t: "Brief & moodboard", d: "Recibo el brief del director creativo o fotógrafo y construyo el moodboard de looks." },
        { t: "Pruebas técnicas", d: "Testeo color, textura y duración bajo luz controlada antes del rodaje." },
        { t: "En set", d: "Ejecución del look + on-set retouching durante toda la producción." },
        { t: "Cambios y wraps", d: "Múltiples looks por sesión cuando el storytelling lo requiere." },
      ],
      en: [
        { t: "Brief & moodboard", d: "I receive the creative director or photographer's brief and build the look moodboard." },
        { t: "Tech tests", d: "I test colour, texture and longevity under controlled light before the shoot." },
        { t: "On set", d: "Look execution + on-set retouching throughout production." },
        { t: "Look changes", d: "Multiple looks per session when storytelling requires it." },
      ],
      jp: [
        { t: "ブリーフ＆ムードボード", d: "クリエイティブディレクターやフォトグラファーのブリーフを受け、ルックのムードボードを作成。" },
        { t: "テクニカルテスト", d: "コントロールされた照明下で色・質感・持続性をテスト。" },
        { t: "撮影現場", d: "ルックの実行＋オンセットのリタッチ。" },
        { t: "ルックチェンジ", d: "ストーリーに応じた複数ルックの対応。" },
      ],
    },
    includes: {
      es: ["Moodboard personalizado", "Pruebas previas de color y duración", "Kit completo en set + on-set retouching", "Múltiples cambios de look por jornada", "Crédito en redes y publicación"],
      en: ["Personalised moodboard", "Pre-shoot colour and longevity tests", "Full on-set kit + on-set retouching", "Multiple look changes per day", "Social and publication credit"],
      jp: ["専用ムードボード", "事前カラー＆持続性テスト", "現場キット＋オンセットリタッチ", "1日複数ルック対応", "SNS＆掲載クレジット"],
    },
    faq: {
      es: [
        { q: "¿Trabajas con marcas internacionales?", a: "Sí, he colaborado con marcas mexicanas e internacionales en producciones nacionales." },
        { q: "¿Cobras por día o por look?", a: "Tarifa por día de producción. Looks múltiples incluidos según briefing." },
        { q: "¿Llevas tu propio kit?", a: "Sí, kit profesional completo: skincare, color, special effects básicos, brushes y airbrush opcional." },
        { q: "¿Puedes trabajar con BTS y video?", a: "Sí, optimizo el maquillaje para cámara digital de alta resolución, película y video." },
      ],
      en: [
        { q: "Do you work with international brands?", a: "Yes, I have collaborated with Mexican and international brands on productions in Mexico." },
        { q: "Do you charge per day or per look?", a: "Day-rate. Multiple looks included per briefing." },
        { q: "Do you bring your own kit?", a: "Yes — complete professional kit: skincare, colour, basic SFX, brushes and optional airbrush." },
        { q: "Can you work with BTS and video?", a: "Yes, makeup optimised for high-resolution digital, film and video." },
      ],
      jp: [
        { q: "海外ブランドとの仕事もありますか？", a: "はい、メキシコ国内外のブランドとのコラボ実績があります。" },
        { q: "料金は1日単位ですか？1ルック単位ですか？", a: "1日単位の料金です。ブリーフに応じて複数ルックを含みます。" },
        { q: "ご自身のキットを持参されますか？", a: "はい、プロ仕様のキット一式（スキンケア、色、簡易SFX、ブラシ、エアブラシ任意）を持参します。" },
        { q: "ビデオ撮影にも対応可能ですか？", a: "はい、高解像度デジタル、フィルム、ビデオに最適化されたメイクを行います。" },
      ],
    },
  },

  eventos: {
    backend_slug: "events",
    hero_image: "https://images.unsplash.com/photo-1613552465135-e5bdaada10bc?crop=entropy&cs=srgb&fm=jpg&q=85",
    gallery_category: "events",
    eyebrow: { es: "Eventos de Belleza", en: "Beauty Events", jp: "ビューティイベント" },
    title: {
      es: "Activaciones, lanzamientos y masterclasses con cara de portada.",
      en: "Activations, launches and masterclasses with a cover-worthy face.",
      jp: "アクティベーション、ローンチ、マスタークラスに、表紙クオリティの顔を。",
    },
    intro: {
      es: "Coberturas para activaciones de marca, lanzamientos de producto, presentaciones de pasarela, masterclasses y eventos del sector belleza. Maquillo a invitadas, embajadoras, modelos y panelistas con looks coherentes y fotogénicos.",
      en: "Coverage for brand activations, product launches, runway presentations, masterclasses and beauty industry events. I do makeup for guests, ambassadors, models and panelists with cohesive, photogenic looks.",
      jp: "ブランドアクティベーション、製品ローンチ、ランウェイ、マスタークラス、ビューティイベントの対応。ゲスト、アンバサダー、モデル、パネリストへの統一感のあるフォトジェニックなメイク。",
    },
    seo_title: {
      es: "Maquillaje para Eventos de Belleza en Aguascalientes · Abril Suarez",
      en: "Beauty Event Makeup Services · Aguascalientes & Mexico · Abril Suarez",
      jp: "ビューティイベント向けメイクサービス · アグアスカリエンテス · アブリル・スアレス",
    },
    seo_desc: {
      es: "Maquillaje profesional para activaciones, lanzamientos, masterclasses y eventos del sector belleza en Aguascalientes y todo México. Tarifa por evento.",
      en: "Professional makeup for activations, launches, masterclasses and beauty industry events in Aguascalientes and across Mexico. Per-event pricing.",
      jp: "アグアスカリエンテスおよびメキシコ全土でのアクティベーション、ローンチ、マスタークラス、ビューティイベント向けのプロフェッショナルメイク。",
    },
    process: {
      es: [
        { t: "Briefing de marca", d: "Definimos cantidad de invitadas, tiempo por look, fotografía y branding." },
        { t: "Equipo según escala", d: "Yo sola hasta 5 invitadas/hora; con equipo asistente para producciones grandes." },
        { t: "Cobertura en vivo", d: "Operación durante el evento + branding del station si la marca lo solicita." },
        { t: "Credit + Reels", d: "Crédito en redes y opción de cobertura BTS para post-evento." },
      ],
      en: [
        { t: "Brand briefing", d: "We define guest count, time per look, photography and branding." },
        { t: "Team to scale", d: "Solo up to 5 guests/hour; with assistant team for larger productions." },
        { t: "Live coverage", d: "Operation during the event + station branding if the brand requires it." },
        { t: "Credit + Reels", d: "Social credit and optional BTS coverage for post-event." },
      ],
      jp: [
        { t: "ブランドブリーフィング", d: "ゲスト数、ルック1人あたりの時間、撮影、ブランディングを定義。" },
        { t: "規模に応じたチーム", d: "1人で1時間5名対応可、大型案件はアシスタントチーム編成。" },
        { t: "ライブ運営", d: "イベント中の運営＋ステーションブランディング対応。" },
        { t: "クレジット＆BTS", d: "SNSクレジット、BTS撮影オプションあり。" },
      ],
    },
    includes: {
      es: ["Briefing y coordinación previa", "Kit profesional + station móvil", "Cobertura por horas o por evento", "Equipo asistente disponible", "Documentación visual del evento"],
      en: ["Pre-event briefing and coordination", "Professional kit + mobile station", "Hourly or per-event coverage", "Assistant team available", "Visual documentation of the event"],
      jp: ["事前ブリーフィング＆調整", "プロキット＋移動式ステーション", "時間制／イベント制対応", "アシスタントチーム手配可能", "イベントのビジュアル記録"],
    },
    faq: {
      es: [
        { q: "¿Tienes equipo asistente?", a: "Sí, para producciones grandes coordino con maquillistas asistentes previamente entrenadas para mantener la coherencia visual." },
        { q: "¿Cuántas personas maquillas por hora?", a: "Promedio 4-5 looks por hora (express). Para look completo, 2-3 por hora." },
        { q: "¿Cobras viáticos?", a: "Aguascalientes ciudad sin cargo. Fuera, viaje y hospedaje a cuenta del cliente." },
      ],
      en: [
        { q: "Do you have an assistant team?", a: "Yes — for large productions I coordinate with pre-trained assistant artists to maintain visual coherence." },
        { q: "How many people per hour?", a: "Avg 4-5 looks per hour (express). For full looks, 2-3 per hour." },
        { q: "Do you charge travel?", a: "Aguascalientes city included. Outside, travel and lodging on client side." },
      ],
      jp: [
        { q: "アシスタントチームはありますか？", a: "はい、大型案件にはトレーニング済みのアシスタントを編成します。" },
        { q: "1時間に何人対応できますか？", a: "エクスプレスで1時間4〜5名、フルルックで2〜3名が目安です。" },
        { q: "交通費はかかりますか？", a: "アグアスカリエンテス市内は込みです。市外は交通・宿泊費を別途請求します。" },
      ],
    },
  },

  sociales: {
    backend_slug: "social",
    hero_image: "https://images.pexels.com/photos/8221202/pexels-photo-8221202.jpeg",
    gallery_category: "events",
    eyebrow: { es: "Eventos Sociales", en: "Social Events", jp: "ソーシャルイベント" },
    title: {
      es: "XV años, graduaciones y celebraciones que merecen estar en cámara.",
      en: "Quinceañeras, graduations and celebrations that deserve to be on camera.",
      jp: "XV成人式、卒業式、特別な記念日のためのメイク。",
    },
    intro: {
      es: "XV años, graduaciones, baby showers, cumpleaños, sesiones de fotos y celebraciones especiales. Looks pensados para acompañarte toda la noche y para que las fotos se vean impecables.",
      en: "Quinceañera, graduations, baby showers, birthdays, photo sessions and special celebrations. Looks designed to last all night and to look impeccable on camera.",
      jp: "成人式、卒業式、ベビーシャワー、誕生日、フォトセッション、特別な記念日に。一晩中崩れず、写真でも美しく仕上がるルック。",
    },
    seo_title: {
      es: "Maquillaje para XV Años, Graduaciones y Eventos Sociales en Aguascalientes",
      en: "Quinceañera, Graduation & Social Event Makeup in Aguascalientes",
      jp: "アグアスカリエンテスの成人式・卒業式・ソーシャルイベントメイク",
    },
    seo_desc: {
      es: "Maquillaje profesional para XV años, graduaciones, sesiones de fotos y eventos sociales en Aguascalientes. Looks duraderos pensados para cámara.",
      en: "Professional makeup for quinceañeras, graduations, photo sessions and social events in Aguascalientes. Long-lasting, camera-ready looks.",
      jp: "アグアスカリエンテスの成人式、卒業式、フォトセッション、ソーシャルイベント向けプロフェッショナルメイク。",
    },
    process: {
      es: [
        { t: "Inspiración", d: "Comparte tus referencias y tu vestido. Te asesoro en paleta y estilo." },
        { t: "Día del evento", d: "Llego a tu casa o salón. Maquillaje en 60-90 minutos." },
        { t: "Kit para ti", d: "Te dejo un mini kit con labial y polvo para retoques discretos." },
      ],
      en: [
        { t: "Inspiration", d: "Share your references and dress. I'll advise on palette and style." },
        { t: "Event day", d: "I come to your home or venue. Makeup in 60-90 minutes." },
        { t: "Mini kit", d: "I leave you with a mini kit (lipstick + powder) for discreet touch-ups." },
      ],
      jp: [
        { t: "インスピレーション", d: "イメージ写真とドレスを共有してください。パレットとスタイルを提案します。" },
        { t: "当日", d: "ご自宅または会場に伺います。所要時間60〜90分。" },
        { t: "ミニキット", d: "リップ＋パウダーのミニキットをお渡しします。" },
      ],
    },
    includes: {
      es: ["Skincare antes del maquillaje", "Pestañas postizas incluidas", "Look duradero 8-10 horas", "Mini kit de retoques", "Asesoría previa por WhatsApp"],
      en: ["Pre-makeup skincare", "False lashes included", "8-10 hour long-lasting look", "Mini touch-up kit", "WhatsApp pre-event consultation"],
      jp: ["メイク前のスキンケア", "付けまつげ込み", "8〜10時間持続", "ミニタッチアップキット", "事前LINE/WhatsApp相談"],
    },
    faq: {
      es: [
        { q: "¿Cuánto tiempo antes del evento debo agendar?", a: "Mínimo 2 semanas. Para temporada alta (mayo-agosto, diciembre), 1-2 meses." },
        { q: "¿Puedes ir a mi casa?", a: "Sí, voy a domicilio en Aguascalientes ciudad sin cargo." },
        { q: "¿Maquillas a más de una persona?", a: "Sí, tengo paquete para grupos pequeños (mamá, hermanas, amigas)." },
      ],
      en: [
        { q: "How far in advance should I book?", a: "Minimum 2 weeks. For high season (May-Aug, December), 1-2 months." },
        { q: "Can you come to my house?", a: "Yes — home visits within Aguascalientes city at no extra charge." },
        { q: "Do you do groups?", a: "Yes, small-group package (mom, sisters, friends) available." },
      ],
      jp: [
        { q: "どのくらい前に予約すべきですか？", a: "最低2週間前。ハイシーズン（5〜8月、12月）は1〜2か月前推奨。" },
        { q: "自宅に来てくれますか？", a: "はい、アグアスカリエンテス市内は無料で出張可能です。" },
        { q: "複数人のメイクも可能？", a: "はい、家族・友人向けの少人数パッケージをご用意しています。" },
      ],
    },
  },
};

export const SERVICE_PAGE_LIST = Object.entries(SERVICE_PAGES).map(([slug, data]) => ({ slug, ...data }));
